"use client";

import React, { memo } from "react";
import clsx from "clsx";
import { LucideIcon } from "lucide-react";
import Text from "@/component/ui/Text";

export type ButtonColor = "primary" | "secondary" | "tertiary" | "disabled";

interface ButtonProps {
  text: string;
  btnType?: "button" | "submit" | "reset";
  color?: ButtonColor;
  icon?: LucideIcon;
  iconSize?: number;
  onClick?: () => void;
  className?: string;
  unStyled?: boolean;
}

const buttonVariants: Record<ButtonColor, string> = {
  primary: "bg-black text-white border border-black hover:bg-accent hover:border-accent",
  secondary: "bg-white text-black border border-black hover:bg-black hover:text-white",
  tertiary: "bg-brandLight text-brand border border-brand hover:bg-brand hover:text-white",
  disabled: "bg-grayLight text-gray border border-gray cursor-not-allowed pointer-events-none",
};

const Button = memo(
  ({
    text,
    btnType = "button",
    color = "disabled",
    icon: Icon,
    iconSize = 16,
    onClick,
    className,
    unStyled = false,
  }: ButtonProps) => {
    return (
      <button
        type={btnType}
        onClick={onClick}
        disabled={color === 'disabled'}
        className={clsx(
          unStyled || "inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer",
          buttonVariants[color], className
        )}
      >
        {Icon && <Icon size={iconSize} stroke="currentColor" />}
        <Text>{text}</Text>
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
